import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import GraphComponent from './GraphComponent';
import PropTypes from 'prop-types';

export default function GraphMain({
  transactionData,
  onGraphNodesChange,
  onGraphEdgesChange,
  onCurrentCenterNodeChange,
}) {
  return (
    <Card variant="outlined" sx={{ width: '100%' }}>
      <CardContent>
        <Typography component="h2" variant="title" gutterBottom>
          Transações
        </Typography>
        <Stack sx={{ justifyContent: 'space-between' }}>
          <Stack
            direction="row"
            sx={{
              alignContent: { xs: 'center', sm: 'flex-start' },
              alignItems: 'center',
              gap: 1,
            }}
          >
          </Stack>
          <GraphComponent
            transactionData={transactionData}
            onGraphNodesChange={onGraphNodesChange}
            onGraphEdgesChange={onGraphEdgesChange}
            onCurrentCenterNodeChange={onCurrentCenterNodeChange}
          />
        </Stack>
      </CardContent>
    </Card>
  );
}

GraphMain.propTypes = {
  transactionData: PropTypes.object,
  onGraphNodesChange: PropTypes.func,
  onGraphEdgesChange: PropTypes.func,
  onCurrentCenterNodeChange: PropTypes.func,
};
